function time(value) {
  const milliseconds = Date.parse(String(value ?? ''))
  return Number.isFinite(milliseconds) ? milliseconds : null
}

function compact(seconds) {
  if (seconds < 60) return `${seconds}s`
  const minutes = Math.floor(seconds / 60)
  const remainder = seconds % 60
  return remainder ? `${minutes}m ${remainder}s` : `${minutes}m`
}

export function timelineInProgressVerb({
  hasResponseText = false,
  thoughtSummary = null,
  hasActivity = false,
}) {
  if (hasResponseText || thoughtSummary === 'Writing answer...') return 'Working'
  if (thoughtSummary === 'Thinking…' || thoughtSummary === 'Starting stream...') {
    return 'Thinking'
  }
  return hasActivity ? 'Working' : 'Thinking'
}

export function liveInProgressLabel(startedAt, now = Date.now(), verb = 'Working') {
  const start = time(startedAt)
  const seconds = start === null ? 1 : Math.max(1, Math.round((now - start) / 1000))
  return `${verb} for ${compact(seconds)}`
}
